import React from "react";
import "./OurReasonSection.css";


import reasonImg1 from "../../Assets/images/acting1.jpg";
import reasonImg2 from "../../Assets/images/love.jpeg";
import reasonImg3 from "../../Assets/images/performer2.jpg";

const OurReasonSection = () => {
  return (
    <section className="our-reason-section">
      {/* TEXT CONTENT */}
      <div className="reason-content">
        <h2 className="reason-title">Our Reason for Being</h2>

        <p className="reason-text">
          Our reason for being, is a consciousness guided by clarity, compassion, and creativity.
        </p>

        <h3 className="reason-subtitle">THE TRUE MEANING OF L.O.V.E & L.I.F.E</h3>
      </div>

      {/* IMAGE COLUMNS */}
      <div className="reason-images">
        <div className="image-column">
          <img src={reasonImg1} alt="reason1" className="reason-image" />
        </div>
        <div className="image-column">
          <img src={reasonImg2} alt="reason2" className="reason-image" />
        </div>
        <div className="image-column">
          <img src={reasonImg3} alt="reason3" className="reason-image" />
        </div>
      </div>
    </section>
  );
};

export default OurReasonSection;